import React, { useState, useEffect } from 'react';
import axios from 'axios';
import LoginForm from '../LoginForm';
import NoticeUploadForm from '../NoticeUploadForm';

const API_URL = 'https://ptlrbackend.onrender.com';

const All = () => {
  const [notices, setNotices] = useState([]);
  const [token, setToken] = useState('');

  // Fetch the notices from the backend
  const fetchNotices = async () => {
    try {
      const response = await axios.get(`${API_URL}/notices`);
      setNotices(response.data);
    } catch (error) {
      console.error('Error fetching notices:', error);
    }
  };

  // Handle notice deletion
  const handleDelete = async (id) => {
    try {
      await axios.delete(`${API_URL}/notices/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchNotices();
    } catch (error) {
      console.error('Error deleting notice:', error);
    }
  };

  useEffect(() => {
    fetchNotices();
  }, []);

  return (
    <div>
      {!token ? (
        <LoginForm setToken={setToken} />
      ) : (
        <>
          <NoticeUploadForm token={token} fetchNotices={fetchNotices} />
          <div>
            <h2>Notices</h2>
            {notices.map((notice) => (
              <div key={notice._id} className="notice">
                <h3>{notice.title}</h3>
                <p>{notice.description}</p>
                {notice.imageURL && (
                  <img
                    src={`${API_URL}${notice.imageURL}`}
                    alt="Notice"
                    style={{ maxWidth: '500px', maxHeight: '700px' }}
                  />
                )}
                <p>{new Date(notice.createdAt).toLocaleString()}</p>
                {token && (
                  <button onClick={() => handleDelete(notice._id)}>
                    Delete
                  </button>
                )}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default All;
